import { render } from "./FloatingActionButton.vue?vue&type=template&id=9211c552&scoped=true&ts=true"
import script from "./FloatingActionButton.vue?vue&type=script&lang=ts"
export * from "./FloatingActionButton.vue?vue&type=script&lang=ts"

import "./FloatingActionButton.vue?vue&type=style&index=0&id=9211c552&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9211c552"]])

export default __exports__